export default function () {
    document.querySelectorAll('.c-youtube').forEach(function (element) {
        if (!element.dataset.embed) return;

        const source = `https://img.youtube.com/vi/${element.dataset.embed}/hqdefault.jpg`;

        // Load the image asynchronously and add it to the element
        const image = new Image(1280, 720); // Sets width and height via constructor
        image.src = source;
        image.loading = 'lazy';
        image.alt = 'Video poster';
        element.appendChild(image);

        element.addEventListener('click', function () {
            this.innerHTML = ''; // Remove existing content (such as the thumbnail)
            const iframe = document.createElement('iframe');
            iframe.setAttribute('frameborder', '0');
            iframe.setAttribute('allowfullscreen', '');
            iframe.setAttribute(
                'src',
                `https://www.youtube.com/embed/${this.dataset.embed}?rel=0&showinfo=0&autoplay=1&mute=1&enablejsapi=1`
            );
            this.appendChild(iframe);
        });
    });
}
